import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CategoryForm from '@/components/v2/ecommerce/CategoryForm.vue';
import CategoryImageUploadMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryImageUploadMixin';
import InquirySubCategoryMixin from '@/helpers/vue_mixins/v2/inquiry/InquirySubCategoryMixin';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import categoryCreate from '@/plugins/graphql/mutations/category-create.gql';
import CategoryFormMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryFormMixin';
import CategoriesQuery from '@/plugins/graphql/queries/categories-basic.gql';
import { isNotEmpty } from '@/helpers';
import { pick } from 'lodash';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let TheCategoryManagerCreate = class TheCategoryManagerCreate extends Mixins(CategoryFormMixin, InquirySubCategoryMixin, CategoryImageUploadMixin, RouterParamsAppMixin, CleverTapEventsMixin) {
    async onSubmit(form) {
        this.requestOnFlight();
        await this.create(form)
            .then(async (res) => {
            const categoryUuid = res.data.categoryCreate.category.uuid;
            if (isNotEmpty(form.subcategories.length)) {
                await this.createSubCategories(categoryUuid, form.subcategories);
            }
            const { inquirySubcategories } = form;
            if (inquirySubcategories && isNotEmpty(inquirySubcategories.length)) {
                await this.createInquirySubCategories(categoryUuid, inquirySubcategories);
            }
            if (isNotEmpty(form.images.length)) {
                await this.uploadImages(categoryUuid, form.images);
            }
            const msg = successfulCreate(this.moduleName);
            this.successNotification(msg);
            this.productCategoryAction('SUBMIT CREATE');
            if (this.modal) {
                this.$emit('closeModal', true);
            }
            else {
                this.goToCategoriesPage();
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const productId = this.componentUUID;
        const appUuid = this.appUUID;
        const vm = this;
        return this.$apollo.mutate({
            mutation: categoryCreate,
            variables: {
                input: {
                    name: form.name,
                    description: form.description,
                    appUuid: this.appUUID,
                    componentUuid: productId,
                    brandUuid: form.brandUuid || null,
                },
            },
            update(cache, { data }) {
                const { category } = data.categoryCreate;
                const basicCategoryQuery = vm.buildQueryOptions(CategoriesQuery, productId, appUuid);
                const { categories: categoriesBasic } = cache.readQuery(basicCategoryQuery);
                if (categoriesBasic) {
                    const basicCategoryDetails = pick(category, [
                        'baseGlobalId',
                        'uuid',
                        'name',
                        'description',
                        'featuredPhotoUrl',
                        'published',
                        'miniAppViews',
                        '__typename',
                    ]);
                    const cachedCategories = vm.getUpdateCachedCategories(categoriesBasic, basicCategoryDetails);
                    cache.writeQuery({
                        ...basicCategoryQuery,
                        data: {
                            categories: cachedCategories,
                        },
                    });
                }
            },
        });
    }
    buildQueryOptions(query, componentUuid, appUuid) {
        return {
            query,
            variables: {
                componentUuid,
                appUuid,
            },
        };
    }
    getUpdateCachedCategories(cachedCategories, category) {
        const cache = { ...cachedCategories };
        cache.edges.unshift({
            node: category,
            __typename: 'CategoryEdges',
        });
        return cache;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], TheCategoryManagerCreate.prototype, "inquiry", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TheCategoryManagerCreate.prototype, "b2b", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TheCategoryManagerCreate.prototype, "modal", void 0);
TheCategoryManagerCreate = __decorate([
    Component({
        components: {
            PageTitle,
            CategoryForm,
        },
    })
], TheCategoryManagerCreate);
export default TheCategoryManagerCreate;
